import { createSelector } from '@reduxjs/toolkit';
import { getSelectedTeamAccount } from './uiSelector';
import { getTeamAccounts } from './portal_selector';
import { EXPENSED_MEALS_PAYMENT_METHOD, EXPENSED_MEALS_STATUS, } from '../types/expensed_meal';
export var getSelectedTeamAccountExpenseMealConfig = createSelector(getTeamAccounts, getSelectedTeamAccount, function (teamAccounts, selectedTeamAccountId) {
    var _a, _b;
    var selectedTeamAccountExpenseMealConfig = (_b = (_a = teamAccounts.find(function (_a) {
        var id = _a.id;
        return id === selectedTeamAccountId;
    })) === null || _a === void 0 ? void 0 : _a.expensedMeals) !== null && _b !== void 0 ? _b : {
        paymentMethod: EXPENSED_MEALS_PAYMENT_METHOD.UNKNOWN,
        status: EXPENSED_MEALS_STATUS.INACTIVE,
    };
    return selectedTeamAccountExpenseMealConfig;
});
